<template>
  <div v-cloak class="view-wrap">
    <div class="view-content stretch">
      <router-view :config="config" :pricing="pricing" :currentUser="currentUser"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding',
  data () {
    return {
      config: {
        productName: 'TB4T_YEARLY_PAYMENT_TRIAL'
      }
    }
  },
  created: function () {
    this.$store.dispatch('getPricingData')
    this.$store.dispatch('getUserData')
  },
  computed: {
    pricing: function () {
      return this.$store.getters.pricingDetails
    },
    currentUser: function () {
      return this.$store.getters.userData
    }
  },
  beforeMount: function () {
    this.$emit('modifyLayout', {
      minimalNav: true,
      minimalFooter: true
    })
    this.$router.afterEach((to, from, next) => {
      this.$emit('modifyLayout', {
        minimalNav: true,
        minimalFooter: true
      })
    })
  }
}
</script>

<style scoped lang="stylus" src="./onboarding.styl" >



// WEBPACK FOOTER //
// src/views/onboarding/onboarding.vue